import type { AxiosResponse } from "axios";
import { createQuery } from "react-query-kit";

import type {
  IApiResponse,
  IAxiosFn,
  IWithFilters,
  IWithPagination,
  IWithStats,
} from "@/api";
import { axiosClient } from "@/api";
import type { AxiosError } from "@api/types.ts";
import { getApi } from "@api/apiPath";
import type { IMspGetAllEndpoint } from "@api/msp/types";

const { key, getPath } = getApi("msp.getAll");

type IResponse = AxiosResponse<
  IApiResponse<IWithStats<IWithFilters<IWithPagination<IMspGetAllEndpoint>>>>
>;
type IVariables = object;

export const getAllMedicalServiceCenter: IAxiosFn<
  IVariables,
  IResponse
> = async (params, signal) => {
  return axiosClient.get(getPath(), {
    params,
    signal,
  });
};

export const useGetAllMedicalServiceCenter = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getAllMedicalServiceCenter(variables, signal),
});
